<template>
	<div class="containers">
		<div class="table-box">
			<pagination v-model="page" :per-page="20" :records="totalDataCount" @paginate="myCallback" />
			<Tableview
				class="table pb-4"
				:hover="true"
				:bordered="true"
				:showNoContent="showContnetFunc"
				:showNoData="showDataFunc"
			>
				<template #TableTitle>
					<tr>
						<th>شماره</th>
						<th>شهر</th>
						<th>استان</th>
						<th>تطابق</th>
						<th>تاریخ شروع</th>
						<th>درصد تطابق</th>
					</tr>
				</template>

				<template #TableBody>
					<tr v-for="(item, index) in frlogList" :key="item.id" class="frlog-detail">
						<td class="persian-number">{{ 1 + index }}</td>
						<td>{{ item.city }}</td>
						<td>{{ item.province }}</td>

						<td>
							<span v-if="item.isavailable" class="status-badge success">بله</span>
							<span v-else class="status-badge danger">خیر</span>
						</td>
						<td>
                            
							<date-picker
								v-model="item.start_date"
								type="datetime"
								format="YYYY-MM-DD"
								display-format="jYYYY-jMM-jDD"
								:timezone="true"
								:disabled="true"
							/>
						</td>

						<td>
							<span v-if="item.visitcard_photo" class="persian-number">{{
								item.visitcard_photo
							}}</span>
							<span v-else class="text-muted">-</span>
						</td>
					</tr>
				</template>
			</Tableview>
		</div>
	</div>
</template>
<script>
import Tableview from '../../components/Tableview/index.vue';
import Pagination from 'vue-pagination-2';

export default {
	components: {
		Tableview,
		Pagination,
	},
	data() {
		return {
			page: 1,
			totalDataCount: 0,
			frlogList: [],
		};
	},
	computed: {
		showContnetFunc() {
			return this.frlogList.length === 0;
		},
		showDataFunc() {
			if (this.frlogList.length !== undefined) {
				return this.frlogList.length === 0;
			}
			return false;
		},
	},
	mounted() {
		this.getFrLogList();
	},
	methods: {
		async getFrLogList(limit = 20, offset = 0) {
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.FRLOG_EDIT +
					'?limit=' +
					limit +
					'&offset=' +
					offset +
					'&ordering=-start_date' +
					'&p=' +
					this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) {
				this.frlogList = res.data.results;
				this.totalDataCount = res.data.count;
			}
		},
		async myCallback() {
			await this.getFrLogList(20, 20 * (this.page - 1));
		},
	},
};
</script>
<style lang="scss" scoped>
.containers {
	padding: 24px;
	// .table {
	// 	border: 1px solid #c4c4c4;
	// }
	.table-box {
		background: #fff;
		border-radius: 8px;
		padding: 24px;
	}
	.frlog-detail {
		cursor: pointer;
	}

	.persian-number {
		font-family: 'IRANYekanfa' !important;
	}

	.status-badge {
		padding: 4px 8px;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 500;

		&.success {
			background-color: #d4edda;
			color: #155724;
		}

		&.danger {
			background-color: #f8d7da;
			color: #721c24;
		}
	}

	.text-muted {
		color: #6c757d;
		font-style: italic;
	}
}
</style>
<style>
.vpd-icon-btn {
	display: none !important;
}
.vpd-input-group input:disabled {
	background: #fff;
	text-align: center;
	min-width: 130px;
	border: none;
	font-family: 'IRANYekanfa' !important;
	font-size: 16px;
}
.VuePagination__count {
	display: none;
}
.page-item.active .page-link {
	background-color: #2d8b8b;
	border-radius: 8px;
}
.page-link {
	border: none;
	color: black;
	font-family: 'IRANYekanfa' !important;
}
</style>
